module.exports = __webpack_public_path__ + "img/13-full-md.27deb357.jpg";